export default "__VITE_ASSET__Y6pwo67f__"